// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as Data17 from "common/src/data/Data17.bs.js";
import * as Data18 from "common/src/data/Data18.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as SupSection from "./SupSection.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as AugmentsInfoPage from "../info/AugmentsInfoPage.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

var augs = [
  [
    "Advanced Loan",
    "Gold",
    "Gain Gold. Your next augment is one tier lower."
  ],
  [
    "Advanced Loan+",
    "Gold",
    "Gain Gold. Your next augment is one tier lower."
  ],
  [
    "Arcane Viktor-y",
    "Gold",
    "After seconds of combat, stun the enemy team for seconds. Repeat this after seconds of combat. TFT Macao Open, 2024"
  ],
  [
    "Ascension",
    "Gold",
    "After seconds of combat, your units gain Damage Amp."
  ],
  [
    "Augmented Power",
    "Silver",
    "Your next augment is one tier higher."
  ],
  [
    "Backline Blueprint",
    "Gold",
    "Gain a 3-cost non-Tank champion and an Emblem that matches their last-listed trait."
  ],
  [
    "Backup Bows",
    "Silver",
    "Gain a Recurve Bow. After your champions attack times, get more."
  ],
  [
    "Band of Thieves",
    "Silver",
    "Gain Thief's Gloves."
  ],
  [
    "Band of Thieves II",
    "Prismatic",
    "Gain Thief's Gloves. After player combats, gain another."
  ],
  [
    "Band of Thieves II+",
    "Prismatic",
    "Gain Thief's Gloves. After player combats, gain another."
  ],
  [
    "Band of Thieves II++",
    "Prismatic",
    "Gain Thief's Gloves. After player combats, gain another."
  ],
  [
    "Baron's Lair",
    "Prismatic",
    "Gain a random Tank item. After seconds of combat, your team gains bonus Attack Damage and Ability Power every second for the rest of combat. TFT Paris Open, 2025"
  ],
  [
    "Beast Within",
    "Gold",
    "Primal grants an additional Blessing. Gain a Vi."
  ],
  [
    "Belt Overflow",
    "Prismatic",
    "Gain Giant's Belts. Your Giant's Belts grant + bonus Health."
  ],
  [
    "Big Grab Bag",
    "Gold",
    "Gain 3 random components, gold, and 1 Reforger."
  ],
  [
    "Birthday Present",
    "Prismatic",
    "Gain a 2-star champion and gold each time you level up. The champion's cost tier is your level minus (max: -cost)"
  ],
  [
    "Birthday Reunion",
    "Gold",
    "Gain 3 Gold. At Level, gain a random -star -cost champion. At Level, gain a Thief's Gloves. At Level, gain a random -star -cost champion. Inkborn Fables Tactician's Crown, 2024"
  ],
  [
    "Blossom's Call",
    "Gold",
    "When you buy a Wisp, gain a random Blossom champion based on the Wisp's cost. Gain 3 Blossom champions."
  ],
  [
    "Bodyguard Training",
    "Gold",
    "Allies gain Armor and Magic Resist, increased by per player level. Gizmos & Gadgets Championship, 2022"
  ],
  [
    "Bonus Gift",
    "Gold",
    "Whenever you open a loot orb, you have a chance to gain a gray loot orb. Gain gray loot orbs."
  ],
  [
    "Bonus Gift +",
    "Gold",
    "Whenever you open a loot orb, you have a chance to gain a gray loot orb. Gain gray loot orbs."
  ],
  [
    "Booster Pack",
    "Gold",
    "Gain gold of random champions. (At least one -cost guaranteed!)"
  ],
  [
    "Booster Pack+",
    "Gold",
    "Gain gold of random champions. (At least one -cost guaranteed!)"
  ],
  [
    "Booster Pack++",
    "Gold",
    "Gain gold of random champions. (At least one -cost guaranteed!)"
  ],
  [
    "Boxing Lessons",
    "Silver",
    "Your team gains Health for each ally that starts combat in the front row."
  ],
  [
    "Branching Out",
    "Silver",
    "Gain a random Emblem."
  ],
  [
    "Branching Out+",
    "Silver",
    "Gain a random Emblem and a Reforger."
  ],
  [
    "Bronze For Life I",
    "Gold",
    "Your team gains Damage Amp for each Bronze-tier trait."
  ],
  [
    "Bronze For Life II",
    "Prismatic",
    "Your team gains Damage Amp and Armor and Magic Resist for each Bronze-tier trait."
  ],
  [
    "Buried Treasures III",
    "Prismatic",
    "Gain a random item component now and at the start of the next rounds."
  ],
  [
    "Calculated Loss",
    "Gold",
    "After losing your combat, gain gold and a free Shop reroll."
  ],
  [
    "Call To Chaos",
    "Prismatic",
    "Gain a powerful and random reward."
  ],
  [
    "Called Shot",
    "Silver",
    "Set your win streak to +. Gain gold."
  ],
  [
    "Capital Gains I",
    "Silver",
    "Store gold equal to of the interest you earn. On -, gain all the stored gold. Gain gold now."
  ],
  [
    "Capital Gains II",
    "Gold",
    "Store gold equal to of the interest you earn. On -, gain all the stored gold. Gain gold now."
  ],
  [
    "Caretaker's Ally",
    "Silver",
    "Gain a random 2-cost champion now. Gain the same one again every time you level up."
  ],
  [
    "Caretaker's Favor",
    "Gold",
    "Gain a component anvil when you reach level 5, 6, 7, and 8. Component anvils offer 4 choices."
  ],
  [
    "Carve a Path",
    "Silver",
    "Gain a B.F. Sword. After your team deals physical damage, gain more."
  ],
  [
    "Celestial Blessing I",
    "Silver",
    "Your team gains Omnivamp. Excess healing is converted to a shield up to Health."
  ],
  [
    "Celestial Blessing II",
    "Gold",
    "Your team gains Omnivamp. Excess healing is converted to a shield up to Health."
  ],
  [
    "Celestial Blessing III",
    "Prismatic",
    "Your team gains Omnivamp. Excess healing is converted to a shield up to Health."
  ],
  [
    "Champ Delivery",
    "Silver",
    "Gain -cost champions. After rounds, gain more."
  ],
  [
    "Champ Delivery +",
    "Silver",
    "Gain -cost champions. After rounds, gain more."
  ],
  [
    "Champ Delivery ++",
    "Silver",
    "Gain -cost champions. After rounds, gain more."
  ],
  [
    "Chosen of the Sun",
    "Gold",
    "Gain a Leona, a Kayle, and a Sejuani. Leona gains permanent max Health each round, increased by for each unique 3-star champion fielded."
  ],
  [
    "Clear Mind",
    "Gold",
    "If there are no champions on your bench at the end of player combat, gain XP."
  ],
  [
    "Clockwork Accelerator",
    "Gold",
    "Your team gains Attack Speed every seconds in combat."
  ],
  [
    "Cluttered Mind",
    "Gold",
    "Gain -cost champions now. If your bench is full at the end of player combat, gain XP."
  ],
  [
    "Cognitive Overload",
    "Gold",
    "Gain gold, -star -cost champion, -cost champion, -cost champions, XP, and Shop reroll."
  ],
  [
    "Cognitive Tax",
    "Silver",
    "Gain gold and XP."
  ],
  [
    "Cognitive Tax+",
    "Silver",
    "Gain gold and XP."
  ],
  [
    "Comeback Story",
    "Prismatic",
    "Your team gains Health and Attack Speed per missing player Health."
  ],
  [
    "Commerce Core",
    "Prismatic",
    "Gain free Shop rerolls now and every round for the rest of the game."
  ],
  [
    "Component Buffet",
    "Silver",
    "Whenever you would get a component, gain a component anvil instead. Gain a random component.The anvil offers 4 choices."
  ],
  [
    "Component Quest",
    "Prismatic",
    "Gain a random component and gold. The next 7 times you win a player combat, gain a different random component. Afterwards, gain a Spatula."
  ],
  [
    "Construct a Companion",
    "Gold",
    "The next -cost champion you buy is -star. Gain gold."
  ],
  [
    "Consuming Flora",
    "Gold",
    "Gain a Flora Fatalis emblem. The champion holding the emblem gains double benefits from the Flora Fatalis trait and gains Mana Regen."
  ],
  [
    "Consuming Flora",
    "Gold",
    "Gain a Flora Fatalis emblem. The champion holding the emblem gains double benefits from the Flora Fatalis trait and gains Mana Regen."
  ],
  [
    "Consuming Flora",
    "Gold",
    "Gain a Flora Fatalis emblem. The champion holding the emblem gains double benefits from the Flora Fatalis trait and gains Mana Regen."
  ],
  [
    "Continuous Conjuration",
    "Silver",
    "Gain a Needlessly Large Rod. After your team deals magic damage, gain more."
  ],
  [
    "Cooking Pot",
    "Gold",
    "At the start of each turn, all units holding a Frying Pan or Spatula item grant the nearest champion permanent Health. Gain a Frying Pan."
  ],
  [
    "Coronation",
    "Prismatic",
    "Gain a Tactician's Crown. Tactician's Crown, Cape, and Shield grant the holder Attack Speed, Attack Damage, and Ability Power."
  ],
  [
    "Corrosion",
    "Silver",
    "Enemies in the first two rows lose Armor and Magic Resist every seconds."
  ],
  [
    "Coven Acolyte",
    "Gold",
    "When you choose to continue gathering Coven essence, heal Tactician health. Gain a Camille, an Elise, and a Caitlyn."
  ],
  [
    "Crafted Crafting",
    "Silver",
    "Whenever you craft a completed item, gain rerolls."
  ],
  [
    "Cry Me A River",
    "Gold",
    "Gain a Tear of the Goddess. Your team gains Mana Regen. After seconds in combat, increase this to."
  ],
  [
    "Cursed Crown",
    "Prismatic",
    "Gain + max team size and your team gains Durability, but you take double player damage when you lose a player combat."
  ],
  [
    "Cybernetic Implants II",
    "Gold",
    "Your champions holding an item gain Health and Attack Damage."
  ],
  [
    "Cybernetic Uplink II",
    "Gold",
    "Your champions holding an item gain Health and Mana Regen. Gain a Tear of the Goddess."
  ],
  [
    "Dark Ritual",
    "Gold",
    "Converting Coven Essence to rewards grants Coven champions Ability Power instead of loot. Gain a Camille, an Elise, and a Caitlyn."
  ],
  [
    "Deadlier Blades",
    "Prismatic",
    "Gain a Deathblade. Deathblades permanently gain Attack Damage whenever their holders score a takedown."
  ],
  [
    "Double Trouble",
    "Gold",
    "When you field exactly 2 copies of a champion, they both gain Attack Damage and Ability Power and Armor, and Magic Resist. When you 3-star, gain a 2-star copy."
  ],
  [
    "Dummify",
    "Silver",
    "Lose all champions on your board and bench. Gain a Training Dummy with of their combined health. The dummy gains Health per stage. Gain a random non-tank 2-star 2 cost champion."
  ],
  [
    "Duo Queue",
    "Gold",
    "Gain 2 random 5-cost champions and 2 copies of a random component"
  ],
  [
    "Early Learnings",
    "Gold",
    "Your team gains% Attack Damage & Ability Power. This increases by% after each player combat. 1-cost champions gain double. TFT Vegas Open, 2023"
  ],
  [
    "Electrocharge I",
    "Silver",
    "Every attacks an ally takes, they deal - (based on current Stage) magic damage to nearby enemies ( second cooldown)."
  ],
  [
    "Electrocharge II",
    "Gold",
    "Every attacks an ally takes, they deal - (based on current Stage) magic damage to nearby enemies ( second cooldown)."
  ],
  [
    "Embiggen",
    "Gold",
    "Your Fae pixies are larger and grant more Attack Damage and Ability Power. Gain a Xayah and a Rakan."
  ],
  [
    "Epic Rolldown",
    "Gold",
    "When you reach Level, gain Shop rerolls. Runeterra Reforged Championship, 2023"
  ],
  [
    "Epoch",
    "Gold",
    "Now, and at the start of every stage, gain XP and free rerolls."
  ],
  [
    "Epoch+",
    "Gold",
    "Now, and at the start of every stage, gain XP and free rerolls."
  ],
  [
    "Exclusive Customization",
    "Gold",
    "Gain a Lucky Item Chest, a Magnetic Remover and gold."
  ],
  [
    "Expected Unexpectedness",
    "Prismatic",
    "Now and at the start of the next 2 stages, roll 3 dice. Gain various rewards based on their total."
  ],
  [
    "Expedition",
    "Silver",
    "At the start of every round, lose the champion in the rightmost bench slot. After losing gold of champions in this way, gain a powerful reward. Gain a 3-cost champion now."
  ],
  [
    "Explosive Growth",
    "Gold",
    "Now and at the start of the next rounds, gain XP."
  ],
  [
    "Explosive Growth+",
    "Gold",
    "Now and at the start of the next rounds, gain XP."
  ],
  [
    "Extra Buckles",
    "Silver",
    "Gain a Giant's Belt. After your team takes damage, get more."
  ],
  [
    "Feeling Lucky",
    "Silver",
    "Gain gold, then flip a coin. If heads, gain more gold."
  ],
  [
    "Find Your Center",
    "Silver",
    "Your champion that starts combat in the center of the front row gains Damage Amp and max Health."
  ],
  [
    "Firesale",
    "Silver",
    "Each round, steal a random -cost or lower champion from the shop. Gain gold."
  ],
  [
    "Flame On",
    "Silver",
    "The Inferno champion that dealt the most damage last combat is On Fire, gaining Attack Speed. Gain a Varus and an Akali."
  ],
  [
    "Flexible",
    "Prismatic",
    "Gain 1 random Emblem. At the start of every Stage, gain a random Emblem. Your team gains Health for each Emblem they are holding."
  ],
  [
    "Flowing Tears",
    "Silver",
    "Gain a Tear of the Goddess. After your team spends Mana, gain more."
  ],
  [
    "Focused Fire",
    "Silver",
    "Your team gains Attack Damage. Every seconds, they gain more."
  ],
  [
    "Forge A Friend",
    "Silver",
    "The next -cost champion you buy is -star. Gain gold."
  ],
  [
    "Forged In Strength",
    "Prismatic",
    "Gain random Artifact. When you drop below Health, gain more random Artifacts. Remix Rumble Championship, 2023"
  ],
  [
    "FOURcing",
    "Gold",
    "Gain a random 4-cost champion. For each item equipped to that champion, your team gains health."
  ],
  [
    "Frontline Foundation",
    "Gold",
    "Gain a 2-star 1-cost Tank champion and an Emblem that matches their last-listed trait."
  ],
  [
    "Future Focused",
    "Silver",
    "Your Tactician loses Health, but after player combats, gain 4-cost champions and gold."
  ],
  [
    "Gain 21 Gold",
    "Gold",
    "Gain gold."
  ],
  [
    "Giant and Mighty",
    "Prismatic",
    "Your team becomes large, gaining Health and max Health."
  ],
  [
    "Gilded Steel",
    "Gold",
    "Gain two 5-cost champions. If you field at least one 5-cost champion, your 1 to 4-cost champions gain Durability. K.O. Coliseum Tactician's Crown, 2025"
  ],
  [
    "Glass Cannon I",
    "Silver",
    "Allies that start combat in the back row begin combat at Health but gain Damage Amp."
  ],
  [
    "Glass Cannon II",
    "Gold",
    "Allies that start combat in the back row begin combat at Health but gain Damage Amp."
  ],
  [
    "Going Long",
    "Prismatic",
    "You no longer gain interest. Gain gold now. Round start: gain XP."
  ],
  [
    "Golden Gamble",
    "Prismatic",
    "Gain gold and flip a coin. If heads, gain a Radiant Lucky Item Chest. If tails, gain Completed Item anvils."
  ],
  [
    "Golden Gamble +",
    "Prismatic",
    "Gain gold and flip a coin. If heads, gain a Radiant Lucky Item Chest. If tails, gain Completed Item anvils."
  ],
  [
    "Golden Gamble ++",
    "Prismatic",
    "Gain gold and flip a coin. If heads, gain a Radiant Lucky Item Chest. If tails, gain Completed Item anvils."
  ],
  [
    "Good For Something I",
    "Silver",
    "Champions that aren't holding items have a chance to drop gold on death."
  ],
  [
    "Group Hug I",
    "Silver",
    "Combat start: Allies grant other adjacent allies Armor and Magic Resist. This effect stacks."
  ],
  [
    "Group Hug II",
    "Gold",
    "Combat start: Allies grant other adjacent allies Armor and Magic Resist. This effect stacks."
  ],
  [
    "Hard Bargain",
    "Gold",
    "You cannot choose your Carousel rewards. Gain an additional player health and gold each carousel round. When you do not pick a Carousel Reward, you are given an unpicked champion and the item it carries."
  ],
  [
    "Hard Commit",
    "Prismatic",
    "Gain a random emblem. Now and at the start of each stage, gain a 1-star champion of that trait with a cost equal to the Stage (max 5) and 3 gold."
  ],
  [
    "Healing Orbs I",
    "Silver",
    "When an enemy dies, the nearest ally is healed for."
  ],
  [
    "Healing Orbs II",
    "Gold",
    "When an enemy dies, the nearest ally is healed for."
  ],
  [
    "Heart of Steel",
    "Gold",
    "Gain a Steadfast Heart. Every seconds of combat its holder survives, Steadfast Heart gains additional permanent max Health."
  ],
  [
    "Hedge Fund",
    "Prismatic",
    "Gain gold. Your max interest is increased to 10."
  ],
  [
    "Heroic Grab Bag",
    "Gold",
    "Gain 2 Lesser Champion Duplicators. Gain Gold"
  ],
  [
    "Heroic Grab Bag+",
    "Gold",
    "Gain 2 Lesser Champion Duplicators. Gain Gold"
  ],
  [
    "Heroic Grab Bag++",
    "Gold",
    "Gain 2 Lesser Champion Duplicators. Gain Gold"
  ],
  [
    "Hold the Line",
    "Prismatic",
    "Allies in your back 2 rows gain Ability Power and Attack Damage for each ally that starts combat in your front row."
  ],
  [
    "Hustler",
    "Gold",
    "You no longer gain interest but gain gold at the start of every player combat round. Gain gold now. Interest is extra gold you gain per g saved."
  ],
  [
    "Infinity Protection",
    "Gold",
    "Gain gold now. On Stage -, gain an Infinity Force. Infinity Force gives allies in the same row a Health shield. Monsters Attack Championship, 2023"
  ],
  [
    "Invested+",
    "Prismatic",
    "Gain 26 gold. At the start of each round, gain 1 Shop reroll for every 10 gold above 50 (max 80 gold)."
  ],
  [
    "Invested++",
    "Prismatic",
    "Gain 45 gold. At the start of each round, gain 1 Shop reroll for every 10 gold above 50 (max 80 gold)."
  ],
  [
    "Investment Strategy I",
    "Gold",
    "Your champions gain permanent max health per interest you earn."
  ],
  [
    "Investment Strategy II",
    "Prismatic",
    "Your champions gain permanent max health per interest you earn. Your max interest is increased by. Gain gold."
  ],
  [
    "Iron Assets",
    "Silver",
    "Gain a component anvil and gold."
  ],
  [
    "Item Extraction",
    "Gold",
    "The first times you sacrifice a champion in the Eldritch hex, gain a copy of a random component they're holding. Gain a Veigar, a Rek'Sai, and item removers."
  ],
  [
    "Item Grab Bag I",
    "Silver",
    "Gain 1 random completed item."
  ],
  [
    "Jeweled Lotus I",
    "Gold",
    "Your team gains% Critical Strike Chance and Precision Precision: Ability damage can critically strike. Additional Precision grants 10% Critical Strike Damage."
  ],
  [
    "Jeweled Lotus II",
    "Prismatic",
    "Your team gains% Critical Strike Chance,% Critical Strike Damage, and Precision. Precision: Ability damage can critically strike. Additional Precision grants 10% Critical Strike Damage."
  ],
  [
    "Jungle Pathing",
    "Gold",
    "Gain a Pebbles, a Cinderling, a Scuttle Crab, and a Murkwolf. Each time you level up, gain a new Riftbeast and gold."
  ],
  [
    "Kick Start",
    "Silver",
    "Gain a random -star -cost champion and gold."
  ],
  [
    "Kingslayer",
    "Silver",
    "After winning player combat, gain gold. If they had more health than you, gain Gold instead. Gain gold."
  ],
  [
    "Know Your Enemy",
    "Gold",
    "You can see who you will fight next. Your team gains Damage Amp, increased to if you and your opponent have any of the same traits active."
  ],
  [
    "Late Game Scaling",
    "Gold",
    "Gain XP at the start of player combat rounds. Your 5-cost champions gain Health and Attack Speed. Cyber City Tactician's Crown, 2025"
  ],
  [
    "Late Game Specialist",
    "Silver",
    "When you reach Level, gain gold."
  ],
  [
    "Latent Forge",
    "Silver",
    "After player combats, gain an Artifact anvil."
  ],
  [
    "Legion Of Threes",
    "Gold",
    "Gain a random Emblem. Your 3-cost champions and all allies equipped with an Emblem gain Health and Attack Speed. Reckoning Championship, 2021"
  ],
  [
    "Level Up!",
    "Prismatic",
    "When you buy XP, gain an additional. Gain immediately."
  ],
  [
    "Living Forge",
    "Prismatic",
    "Gain an Artifact Anvil now and after every player combats."
  ],
  [
    "Loaded Dice",
    "Silver",
    "Your dice always roll 6 and your coins always flip heads. Roll a die and gain gold equal to the number rolled. Then flip a coin and gain gold if you flip heads."
  ],
  [
    "Lucky Gloves",
    "Prismatic",
    "Thief's Gloves will always give your champions ideal items. Gain Sparring Gloves."
  ],
  [
    "Lucky Gloves+",
    "Prismatic",
    "Thief's Gloves will always give your champions ideal items. Gain Sparring Gloves now, then another after player combats."
  ],
  [
    "Luxury Subscription",
    "Prismatic",
    "Gain a package containing a -cost champion, a 2-star -cost champion, and gold. At the start of the next stages, gain the package again."
  ],
  [
    "Magic Roll",
    "Gold",
    "Roll 3 dice. Gain rewards based on their total. Reward: [Placeholder]"
  ],
  [
    "Makeshift Armor I",
    "Silver",
    "Allies without items equipped gain Armor and Magic Resist."
  ],
  [
    "Makeshift Armor II",
    "Gold",
    "Allies without items equipped gain Armor and Magic Resist."
  ],
  [
    "Malicious Monetization",
    "Gold",
    "Gain gold. For the next rounds, enemy champions drop gold when killed."
  ],
  [
    "Max Build",
    "Gold",
    "Gain free Shop rerolls. When you reach level, gain free Shop rerolls and a Champion Duplicator. Galaxies Championship, 2020"
  ],
  [
    "Min-Max",
    "Prismatic",
    "Gain a Golden Item Remover and 4 random components."
  ],
  [
    "Missed Connections",
    "Silver",
    "Gain a copy of each 1-cost champion."
  ],
  [
    "Money Hungry",
    "Gold",
    "Gain gold now, then gold at the start of every stage. Picking up gold makes your Tactician larger."
  ],
  [
    "Money Hungry+",
    "Gold",
    "Gain gold now, then gold at the start of every stage. Picking up gold makes your Tactician larger."
  ],
  [
    "Money Monsoon",
    "Prismatic",
    "Gain gold now and every round for the rest of the game."
  ],
  [
    "Nature's Shelter",
    "Gold",
    "Champions that start combat adjacent to an Elderwood plant gain Attack Speed and heal of their maximum Health every seconds. Gain 3 Elderwood champions."
  ],
  [
    "Nesting Anvils",
    "Prismatic",
    "Gain an Artifact Anvil. After you open it, gain a Completed Item Anvil. After you open that, gain a Component Anvil. After you open that, gain gold."
  ],
  [
    "Nesting Anvils +",
    "Prismatic",
    "Gain an Artifact Anvil. After you open it, gain a Completed Item Anvil. After you open that, gain a Component Anvil. After you open that, gain gold."
  ],
  [
    "Nesting Dolls",
    "Prismatic",
    "After a champion dies in combat, spawn a copy of them one star level lower with health. Gain free rerolls"
  ],
  [
    "Nesting Dolls",
    "Prismatic",
    "After a champion dies in combat, spawn a copy of them one star level lower with health. Gain free rerolls"
  ],
  [
    "Nesting Dolls",
    "Prismatic",
    "After a champion dies in combat, spawn a copy of them one star level lower with health. Gain free rerolls"
  ],
  [
    "New Recruit",
    "Prismatic",
    "Gain + max team size and 4-cost champion"
  ],
  [
    "New Recruit +",
    "Prismatic",
    "Gain + max team size and 4-cost champions"
  ],
  [
    "NO SCOUT NO PIVOT",
    "Gold",
    "Champions that fight in player combat cannot be benched or sold. Your team gains Health, and Attack Damage and Ability Power after player combat."
  ],
  [
    "Omega Riftbeast",
    "Gold",
    "You can now choose a second Alpha Riftbeast. Gain 3 Riftbeasts."
  ],
  [
    "One Buff Two Buff",
    "Prismatic",
    "Gain a Red Buff, a Blue Buff, and a Champion Duplicator."
  ],
  [
    "One Two Three",
    "Silver",
    "Gain 1 1-cost champion, 1 2-cost champion, and 1 3-cost champion."
  ],
  [
    "One, Two, Five!",
    "Silver",
    "Gain 1 random component, gold, and 1 random 5-cost champion"
  ],
  [
    "Pandora's Items I",
    "Silver",
    "Round start: items on your bench are randomized. Gain random component."
  ],
  [
    "Pandora's Items II",
    "Gold",
    "Round start: items on your bench are randomized. Gain random components."
  ],
  [
    "Pandora's Items III",
    "Prismatic",
    "Round start: items on your bench are randomized. Gain Radiant item."
  ],
  [
    "Partial Ascension",
    "Silver",
    "After seconds of combat, your units gain Damage Amp."
  ],
  [
    "Patience Is A Virtue",
    "Silver",
    "Each round, gain free rerolls if you did not buy a champion last round."
  ],
  [
    "Patient Study",
    "Gold",
    "After player combat, gain XP if you won or XP if you lost."
  ],
  [
    "Phreaky Friday",
    "Prismatic",
    "Gain an Infinity Force. After 5 player combats, gain another. Infinity Force: Artifact that offers tons of offensive and defensive stats"
  ],
  [
    "Phreaky Friday+",
    "Prismatic",
    "Gain an Infinity Force. After 3 player combats, gain another. Infinity Force: Artifact that offers tons of offensive and defensive stats."
  ],
  [
    "Pilfer",
    "Gold",
    "Each round, gain a 1-star copy of the first champion you killed last combat. The first time you gain gold worth of champions in this way, gain a Thief's Gloves."
  ],
  [
    "Portable Forge",
    "Gold",
    "Choose 1 of 4 Artifacts. Artifacts are more powerful items with a unique effect."
  ],
  [
    "Precision and Grace",
    "Gold",
    "At the start of combat, allies gain Attack Speed for seconds. On takedown, allies dash to their next target and gain this bonus again."
  ],
  [
    "Prismatic Ticket",
    "Prismatic",
    "Each time your shop is rerolled you have a% chance to gain a free reroll."
  ],
  [
    "Promised Protection",
    "Gold",
    "Gain a Protector's Vow. Protector's Vow grants its holder additional Mana from all sources."
  ],
  [
    "Quick Streaks",
    "Silver",
    "You gain twice as much progress towards win and loss streaks. Gain gold."
  ],
  [
    "Radiant Rascal",
    "Prismatic",
    "Gain a Radiant Thief's Gloves item. This equips 2 random Radiant items every round."
  ],
  [
    "Radiant Relics",
    "Prismatic",
    "Choose 1 of 5 Radiant Items. Gain a Magnetic Remover."
  ],
  [
    "Razor's Edge",
    "Gold",
    "Gain a 2-star 2-cost champion and Item Removers. After winning a player combat, gain gold per item component on your item bench."
  ],
  [
    "Recombobulator",
    "Silver",
    "Champions on your board permanently transform into random champions 1 cost tier higher (max 5). Gain Magnetic Removers."
  ],
  [
    "Replication",
    "Gold",
    "Choose 1 of 3 components. For the next rounds, gain a copy of that component."
  ],
  [
    "Residual Magic",
    "Silver",
    "Your team gains Health. Each time you purchase a Wisp, increase this by."
  ],
  [
    "Residual Magic +",
    "Silver",
    "Your team gains Health. Each time you purchase a Wisp, increase this by."
  ],
  [
    "Residual Magic ++",
    "Silver",
    "Your team gains Health. Each time you purchase a Wisp, increase this by."
  ],
  [
    "Retribution",
    "Prismatic",
    "Gain Hands of Justice. Allies equipped with Hand of Justice gain Precision and Critical Strike Chance. Precision: Ability damage can critically strike. Additional Precision grants 10% Critical Strike Damage."
  ],
  [
    "Rolling For Days",
    "Silver",
    "Gain free Shop rerolls."
  ],
  [
    "Salvage Bin",
    "Gold",
    "Gain 1 random completed item now, and 1 component after player combats. Selling champions breaks completed items into components (excluding Tactician's items and Emblems)."
  ],
  [
    "Salvage Bin+",
    "Gold",
    "Gain 1 random completed item now, and 1 component after player combats. Selling champions breaks completed items into components (excluding Tactician's items and Emblems)."
  ],
  [
    "Seraphim's Staff",
    "Gold",
    "Gain an Archangel's Staff. Archangel's Staff grants additional Mana Regen if its holder has or more Ability Power."
  ],
  [
    "Shimmerscale Essence",
    "Prismatic",
    "Gain a Mogul's Mail. After player combats, gain a Gamblers Blade. These items give gold as well as combat power."
  ],
  [
    "Shopping Spree",
    "Prismatic",
    "When you level up, gain a number of free shop refreshes equal to your level +. Gain gold."
  ],
  [
    "Silver Spoon",
    "Silver",
    "Gain XP"
  ],
  [
    "Slammin'",
    "Gold",
    "Gain gold. After each player combat, if there are no items on your bench (other than consumables), gain XP."
  ],
  [
    "Slammin'+",
    "Gold",
    "Gain gold and XP now. After each player combat, if there are no items on your bench (other than consumables), gain XP."
  ],
  [
    "Slice of Life",
    "Silver",
    "Twice per stage, gain a random champion. Its cost increases by Stage. This effect ends after receiving -cost champion."
  ],
  [
    "Slightly Magic Roll",
    "Silver",
    "Roll a die. Gain rewards based on the number rolled."
  ],
  [
    "Small Furry Friend",
    "Gold",
    "While Sprykin is active, gain a second BFF summon that is as powerful. Gain 3 Sprykin champions."
  ],
  [
    "Small Grab Bag",
    "Silver",
    "Gain random item components."
  ],
  [
    "Solo Leveling",
    "Gold",
    "For the next combats, your team size is, but the champion you field has massively increased stats. Gain XP for every kill they get. Afterwards, gain item components."
  ],
  [
    "Solo Plate",
    "Gold",
    "Gain a Gargoyle Stoneplate. Combat start: Allies holding Gargoyle Stoneplate gain max Health if they're the only one in their row."
  ],
  [
    "Soul Awakening",
    "Prismatic",
    "Combat start: Your team gains Attack Damage and Ability Power per second for seconds. At max stacks, deal bonus true damage."
  ],
  [
    "Speedy Double Kill",
    "Gold",
    "Gain a Guinsoo's Rageblade. When players are eliminated, gain gold. Fates Championship, 2021"
  ],
  [
    "Spirit Of Redemption",
    "Gold",
    "Gain a Spirit Visage. Every seconds, Spirit Visage heals allies within hex for of their missing Health."
  ],
  [
    "Spreading Roots",
    "Gold",
    "Gain random Emblems and gold."
  ],
  [
    "Spreading Roots+",
    "Gold",
    "Gain random Emblems, a Reforger, and gold."
  ],
  [
    "Staffsmith",
    "Gold",
    "Gain random completed items that build from Needlessly Large Rod."
  ],
  [
    "Stand United",
    "Silver",
    "Your units gain Attack Damage and Ability Power for each non-unique Trait active across your team."
  ],
  [
    "Starring Up",
    "Prismatic",
    "After 3-starring champions, set your level to. Gain rerolls now and at the start of every round."
  ],
  [
    "Sun and Moon",
    "Gold",
    "Your Lunar champions gain Health and Damage Amp for each unique Solar champion fielded. Gain a 2-star Leona, a Kayle, and an Aphelios."
  ],
  [
    "Sun and Moon",
    "Gold",
    "Your Lunar champions gain Health and Damage Amp for each unique Solar champion fielded. Gain a Leona, a Kayle, and a Diana."
  ],
  [
    "Sweet Treats",
    "Prismatic",
    "Gain an Artifact anvil. Your team gains Health for each item equipped on champions."
  ],
  [
    "Sword Overflow",
    "Prismatic",
    "Gain BF Swords. Your BF Swords grant + Attack Speed."
  ],
  [
    "Swordsmith",
    "Gold",
    "Gain random completed items that build from B.F. Sword."
  ],
  [
    "Tactician's Kitchen",
    "Prismatic",
    "Gain a random Emblem. After rounds, gain a Tactician's Cape."
  ],
  [
    "Team Building",
    "Silver",
    "Gain a Lesser Champion Duplicator. Gain another after player combats. This item allows you to copy a 3-cost or less champion."
  ],
  [
    "The Golden Dragon",
    "Gold",
    "Gain a Mogul's Mail. Champions holding Mogul's Mail take up + team slot but gain Health and Durability."
  ],
  [
    "The Golden Egg",
    "Prismatic",
    "Gain a golden egg that hatches in turns for a huge amount of loot. Winning player combat speeds up the hatch timer by an extra turn."
  ],
  [
    "The Tower",
    "Silver",
    "Gain a giant Training Dummy. Every seconds, it zaps the nearest enemies dealing max Health true damage."
  ],
  [
    "The Trait Tree",
    "Prismatic",
    "Gain random Emblems and gold."
  ],
  [
    "The Trait Tree+",
    "Prismatic",
    "Gain random Emblems, a Reforger, and gold."
  ],
  [
    "Time Skip",
    "Gold",
    "Disable your Shop for the next rounds. Then gain XP."
  ],
  [
    "Tons of Stats!",
    "Gold",
    "Your team gains Health, Attack Damage, Ability Power, Armor, Magic Resist, Attack Speed, and Mana."
  ],
  [
    "TONS of Stats!",
    "Prismatic",
    "Your team gains Health, Attack Damage, Ability Power, Armor, Magic Resist, Attack Speed, and Mana."
  ],
  [
    "Trade Sector",
    "Gold",
    "Gain a free Shop reroll every round. Gain gold."
  ],
  [
    "Trade Sector +",
    "Gold",
    "Gain a free Shop reroll every round. Gain gold."
  ],
  [
    "Trait Ladder",
    "Prismatic",
    "Gain a random emblem. After fielding non-unique traits in a player combat, gain a reward. Then increase the number of traits needed and the size of the reward."
  ],
  [
    "Twin Guardians",
    "Silver",
    "If you have exactly allies in your first row, grant them Health, Armor, and Magic Resist."
  ],
  [
    "Two Much Value",
    "Gold",
    "Gain reroll for every unique 2-cost champions fielded last player combat. Gain 2-cost champions."
  ],
  [
    "Upward Mobility",
    "Prismatic",
    "Buying XP costs less. Gain Health and free reroll whenever you level up."
  ],
  [
    "URF",
    "Gold",
    "Gain a Spatula. Champions holding Spatula or Frying Pan items gain Attack Speed and Mana Regen"
  ],
  [
    "Urf's Grab Bag",
    "Prismatic",
    "Gain Spatula, random components, and gold."
  ],
  [
    "Verticality I",
    "Silver",
    "Champions gain Attack Damage, Ability Power, Armor, and Magic Resist for each ally that shares a trait with them."
  ],
  [
    "Verticality II",
    "Gold",
    "Champions gain Attack Damage, Ability Power, Armor, and Magic Resist for each ally that shares a trait with them."
  ],
  [
    "Verticality III",
    "Prismatic",
    "Champions gain Attack Damage, Ability Power, Armor, and Magic Resist for each ally that shares a trait with them."
  ],
  [
    "Wand Overflow",
    "Prismatic",
    "Gain Needlessly Large Rods. Your Needlessly Large Rods grant + Attack Speed."
  ],
  [
    "Warpath",
    "Gold",
    "Gain a 2-star 2-cost champion. After dealing player damage, gain a chest of high cost champions and items."
  ],
  [
    "We Stick Together",
    "Prismatic",
    "Gain a random Emblem and a completed item anvil. Allies that share a trait with that Emblem gain Attack Speed. Into The Arcane Tactician's Crown, 2025"
  ],
  [
    "Weight The Worth",
    "Silver",
    "Whenever you 3-star a champion, gain a copy of them each round for the rest of the game. Gain a Lesser Champion Duplicator."
  ],
  [
    "Wisp Rebate",
    "Silver",
    "Each time you purchase a Wisp, gain gold. Gain gold now."
  ],
  [
    "Wisp Rebate +",
    "Silver",
    "Each time you purchase a Wisp, gain gold. Gain gold now."
  ],
  [
    "Worth the Wait",
    "Gold",
    "Gain a random 1-cost champion. Gain another copy of them at the start of each round for the rest of the game."
  ],
  [
    "Worth the Wait II",
    "Prismatic",
    "Gain 2 copies of a random 2-cost champion. Gain another copy of them at the start of each round for the rest of the game."
  ],
  [
    "Woven Magic",
    "Gold",
    "Gain a random item component. Every Mana your team spends grants an additional component."
  ],
  [
    "Young and Wild and Free",
    "Silver",
    "You can always move freely on Carousel rounds. Gain gold."
  ]
];

var stageLabels = [
  "2-1",
  "3-2",
  "4-2"
];

function SupAugments$AugmentCard(Props) {
  var name = Props.name;
  var rank = Props.rank;
  var desc = Props.desc;
  return React.createElement(ContentSection.make, {
              className: "pt-3 pb-2",
              children: null
            }, React.createElement("div", {
                  className: "flex items-center gap-2 pb-2"
                }, React.createElement(AugmentImage.make, {
                      augId: name,
                      size: 42,
                      rank: rank
                    }), React.createElement("div", {
                      className: "font-montserrat font-medium py-1"
                    }, name)), React.createElement(RitoDescription2.make, {
                  desc: desc,
                  className: "text-sm leading-tight"
                }));
}

var AugmentCard = {
  make: SupAugments$AugmentCard
};

function SupAugments(Props) {
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return false;
      });
  var showAll = match[0];
  var allAugments = React.useMemo((function () {
          if (showAll) {
            return Js_dict.entries(Data18.augments);
          } else {
            return Belt_Array.keep(Js_dict.entries(Data18.augments), (function (param) {
                          return Belt_Option.isNone(Js_dict.get(Data17.augments, param[0]));
                        }));
          }
        }), [showAll]);
  var silverAugments = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.keep(allAugments, (function (param) {
                            return param[1].rank === 1;
                          })), (function (param, param$1) {
                        return Caml.caml_string_compare(param[1].name, param$1[1].name);
                      }));
        }), [allAugments]);
  var goldAugments = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.keep(allAugments, (function (param) {
                            return param[1].rank === 2;
                          })), (function (param, param$1) {
                        return Caml.caml_string_compare(param[1].name, param$1[1].name);
                      }));
        }), [allAugments]);
  var prismAugments = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.keep(allAugments, (function (param) {
                            return param[1].rank === 3;
                          })), (function (param, param$1) {
                        return Caml.caml_string_compare(param[1].name, param$1[1].name);
                      }));
        }), [allAugments]);
  return React.createElement(SupSection.make, {
              children: null,
              id: "set-update-augments",
              title: t("Augments")
            }, React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:grid-rows-[repeat(2,minmax(170px,auto))] gap-8"
                }, Belt_Array.map(silverAugments, (function (param) {
                        var augId = param[0];
                        return React.createElement(AugmentsInfoPage.Cell.make, {
                                    id: augId,
                                    info: param[1],
                                    key: augId
                                  });
                      }))), React.createElement("div", {
                  className: "py-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:grid-rows-[repeat(4,minmax(170px,auto))] gap-8"
                }, Belt_Array.map(goldAugments, (function (param) {
                        var augId = param[0];
                        return React.createElement(AugmentsInfoPage.Cell.make, {
                                    id: augId,
                                    info: param[1],
                                    key: augId
                                  });
                      }))), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:grid-rows-[repeat(4,minmax(170px,auto))] gap-8"
                }, Belt_Array.map(prismAugments, (function (param) {
                        var augId = param[0];
                        return React.createElement(AugmentsInfoPage.Cell.make, {
                                    id: augId,
                                    info: param[1],
                                    key: augId
                                  });
                      }))));
}

var pageSize = 12;

var make = SupAugments;

export {
  augs ,
  stageLabels ,
  AugmentCard ,
  pageSize ,
  make ,
  
}
/* react Not a pure module */
